const listRoute = (type) =>
    type === "feis" ? "/feis" : type === "grade" ? "/grade" : type === "oireachtas" ? "/oireachtas" : "/";

export const backHandler = (ID, navigate, eventName, type) => {
    if (localStorage.getItem("ID")) {
        redirectHandler(ID, navigate, type)
    } else {
        navigate(listRoute(type));
    }
};

const redirectHandler = (ID, navigate, type) => {
    const redirectFeis = localStorage.getItem("redirectFeis");
    const manage = localStorage.getItem("Manage");
    if (redirectFeis === "goLive") {
        localStorage.removeItem("redirectFeis")
        const path = type === "feis" ? "/feis/create/finalFeisDetails" : type === "grade" ? "/grade/create/finalGradeDetails" : type === "oireachtas" ? "/oireachtas/create/finalOireachtasDetails" : "/"
        navigate(path)
    }
    else if (redirectFeis === "edit") {
        localStorage.removeItem("redirectFeis")
        navigate(type === "feis" || type === "grade" ? `/event-details?id=${ID}&Manage=${type}` : `/event-details?id=${ID}`);
    } else if (redirectFeis === "create") {
        localStorage.removeItem("redirectFeis")
        navigate("/");

    } else if (manage) {
        const path = type === "feis" ? `/feis/manage?id=${ID}&Manage=feis` : type === "grade" ? `/grade/manage?id=${ID}&Manage=grade` : "/";
        navigate(path);
    } else {
        navigate(listRoute(type));
    }
}
